import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React from 'react';

import { ConfirmActionParams } from '../../providers/plex_provider';
import { ButtonColor, PlexButton } from './primitives/PlexButton';

interface Props {
  dialogData: ConfirmActionParams & { open: boolean };
  onClose: (dialogData: ConfirmActionParams & { open: boolean }) => void;
}

export const ConfirmationDialog = (props: Props): React.ReactElement => {
  const { dialogData, onClose } = props;
  const classes = useStyles();

  return (
    <Dialog
      onClose={(): void => onClose(dialogData)}
      open={dialogData.open}
      classes={{ paper: classes.dialogContainer }}
    >
      {!!dialogData.title && <DialogTitle>{dialogData.title}</DialogTitle>}
      {!!dialogData.message && (
        <DialogContent>
          <DialogContentText>{dialogData.message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <PlexButton
          color={ButtonColor.TransparentBlack}
          label={'Cancel'}
          {...dialogData.cancelButton}
          onClick={(event: React.MouseEvent<HTMLElement>): void => {
            if (!!dialogData.cancelButton?.onClick) {
              dialogData.cancelButton?.onClick(event);
            }
            onClose(dialogData);
          }}
        />
        {!!dialogData.confirmButton && (
          <PlexButton
            color={ButtonColor.Primary}
            {...dialogData.confirmButton}
            onClick={(event: React.MouseEvent<HTMLElement>): void => {
              if (!!dialogData.confirmButton?.onClick) {
                dialogData.confirmButton.onClick(event);
              }
              onClose(dialogData);
            }}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  dialogContainer: { minWidth: 400 },
}));
